import {
  createContext,
  Dispatch,
  SetStateAction,
  Suspense,
  useContext,
  useMemo,
  useState,
} from 'react';

import { Route, Routes } from 'react-router-dom';
import c, { COMPOSER_TYPES } from 'utils/constants';
import {
  useRolePermissionContext,
  useValidateRolePermission as validateRolePermission,
} from 'utils/providers/RolePermission';
import { Error, Loading } from 'pages';
import { Composer } from 'ui/partials';

import Fields from './Fields';

const ROUTES = [
  {
    path: '/fields',
    element: () => <Fields />,
    acl: [c.PERMISSION_KEYS.WEBHOOKS], // Change later to FIELDS
  },
];

interface CONTEXT {
  selectedFieldId?: string | null;
  setSelectedFieldId?: Dispatch<SetStateAction<string | null>>;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  isOpen?: boolean;
  clearFieldId?: () => void;
  handleClose?: (...callbacks: (() => void)[]) => void;
}

export const DataManagementContext = createContext<CONTEXT>({
  selectedFieldId: '',
});

// eslint-disable-next-line react-refresh/only-export-components
export const useDataManagementContext = () => useContext(DataManagementContext);

const DataManagement = () => {
  const {
    state: { rolePermissions },
  } = useRolePermissionContext();
  const [selectedFieldId, setSelectedFieldId] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = (...callbacks: (() => void)[]) => {
    setSelectedFieldId(null);
    setIsOpen(false);
    callbacks.forEach((callback) => callback());
  };
  const routes = useMemo(() => {
    // TODO: Type this properly
    let _routes: any[] = [];

    if (rolePermissions) {
      _routes = ROUTES.filter(({ acl }) =>
        validateRolePermission(rolePermissions, acl),
      );
    }

    return _routes;
  }, [rolePermissions]);

  const value = useMemo(
    () => ({
      selectedFieldId,
      setSelectedFieldId,
      clearFieldId: () => setSelectedFieldId(null),
      setIsOpen,
      isOpen,
      handleClose,
    }),
    [isOpen, selectedFieldId],
  );

  return (
    <Suspense fallback={<Loading />}>
      <DataManagementContext.Provider value={value}>
        <Routes>
          {routes.map(({ path, element, index }) => (
            <Route
              key={Math.random()}
              path={path}
              index={Boolean(index)}
              element={element()}
            />
          ))}
          <Route path="*" element={<Error />} />
        </Routes>
        {(!!selectedFieldId || isOpen) && (
          <Composer
            className="w-[450px]"
            type={COMPOSER_TYPES.field}
            onSubmit={async () => {}}
            closeComposer={() => {
              setSelectedFieldId(null);
              setIsOpen(false);
            }}
            isOpen={!!selectedFieldId || isOpen}
          />
        )}
      </DataManagementContext.Provider>
    </Suspense>
  );
};

export default DataManagement;
